import BenefitsCircle from './BenefitsCircle';

export default BenefitsCircle;
